import { IsBoolean, IsObject, IsOptional } from "class-validator";

export class ReadAccessProjectResponseDto {
  @IsObject()
  @IsOptional()
  project: Record<string, unknown> | undefined;

  @IsBoolean()
  showPrices: boolean = false;
}
